import type { LocationRepository } from '@/core/location'
import type { UseCase } from '@/core/shared'

export const deleteLocation: UseCase<LocationRepository, 'deleteLocation'> = repository => {
  return async (locationId) => {
    await repository.deleteLocation(locationId)
  }
}
